import Blue from "~/core";

new Blue({
  name: "Stat Counter",
  selector: ".stat-counter",
  setup(number) {
    const value = number.querySelector('.counter');
    // const highlight =( number.querySelector('#highlight'));

    const patt = /(\D+)?(\d+)(\D+)?(\d+)?(\D+)?/;
    const time = 1000;
    let result = [...patt.exec(value.innerText)];
    let fresh = true;
    let ticks;

    // Remove first full match from result array (we dont need the full match, just the individual match groups).
    result.shift();
    // Remove undefined values from result array where they didnt have a match in one of the optional regex groups
    result = result.filter((res) => res != null);

    while (value.firstChild) {
      value.removeChild(value.firstChild);
    }

    for (let res of result) {
      if (isNaN(res)) {
        value.insertAdjacentHTML("beforeend", `<span>${res}</span>`);
      } else {
        for (let i = 0; i < res.length; i++) {
          value.insertAdjacentHTML(
            "beforeend",
            `<span data-value="${res[i]}">
						<span>&ndash;</span>
						${Array(parseInt(res[i]) + 1)
              .join(0)
              .split(0)
              .map(
                (x, j) => `
							<span>${j}</span>
						`
              )
              .join("")}
					</span>`
          );
        }
      }
    }

    ticks = [...value.querySelectorAll("span[data-value]")];
    let activate = () => {
		let top = value.getBoundingClientRect().top;
		let offset = window.innerHeight * 1;
		setTimeout(() => {
			fresh = false;
		}, time);

		if (top < offset) {
			setTimeout(() => {

				for (let tick of ticks) {
					let dist = parseInt(tick.getAttribute("data-value")) + 1;
					tick.style.transform = `translateY(-${dist * 100}%)`;
          // if(highlight){
          //   highlight.classList.add("animated");

          // }
				}
			}, fresh ? time : 0);
			window.removeEventListener("scroll", activate);
		}
	};
	window.addEventListener("scroll", activate);
	activate();
  },
  
});
